// extracted by mini-css-extract-plugin
module.exports = {"header":"infoBus_header__G7ohy","chofer":"infoBus_chofer__2sAYt","configuration":"infoBus_configuration__3dO5X"};